import React from 'react';
import DiamondGrid from './DiamondGrid/DiamondGrid';
import WorkSection from './WorkSection/WorkSection';
import Alliances from './Alliances/Alliances';
import Banner from '../../Layout/Banner/Banner';

const Home = () => {
  return (
    <div className='container-mh'>
      <Banner />
      <DiamondGrid />
      <WorkSection />
      <Alliances />
    </div>
  )
}

export default Home